'use strick';

import React from 'react';
// import Map from './../../../../global/mapReactLibrary/MapSimple.jsx';


// import * as React from 'react';
// import GoogleMapReact from 'google-map-react';

import fetch from 'isomorphic-fetch';
import {
    compose,
    withProps,
    withStateHandlers,
    withHandlers
} from 'recompose';

import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import { isEmpty } from 'lodash'
import { Box, Card, AppBar, Tabs, Tab } from '@material-ui/core';
/*import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from 'react-google-maps';


import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
*/


const defineCenter = (markers) => {
  // console.log(markers);
	console.log('defining center of : ', markers);
	if (!isEmpty(markers)) {
		return {lat: 0, lng: 0};
	}
	//Remove Zero markers
	let markersWithNoZero = []
	markers.forEach((e) => {
		if (!(e.latitude === 0 || e.longitude === 0)){
		//console.log(e);
		markersWithNoZero.push(e) 
		}
	}); 
	if (!isEmpty(markersWithNoZero)) {
		return {lat: 0, lng: 0};
	}
	let center = markersWithNoZero.reduce((acc, marker) => {
		// console.log(acc);
		return acc = {
		lat: acc.lat + marker.latitude,
		lng: acc.lng + marker.longitude
		};
	}, {lat: 0, lng: 0});

	center = {
		lat: center.lat / markersWithNoZero.length,
		lng: center.lng / markersWithNoZero.length
	};
	console.log(center);
	// console.log('IN defineCenter : ', center);
	return center;
};

// interface CustomMarkerProps {
//   id: number;
//   marker: any;
// }
class CustomMarker extends React.Component {
	state = {
		index: 0
	};
	onToggleOpen = (index) => {
		this.setState({
		index: index
		});
	}
	render() {
		return (
			<Marker
				key={this.props.id}
				position={{ lat: this.props.marker.latitude, lng: this.props.marker.longitude }}
				onClick={() => this.onToggleOpen(this.props.id)}
			>
				{ this.state.index === this.props.id && "ok"
				/*<InfoWindow onCloseClick={this.onToggleOpen}>
				<p>{this.props.marker.userID}</p>
				</InfoWindow>
				*/
				}
			</Marker>
		);
	}
}

// interface MapWithMarkersProps {
//   markers: any;
//   center: {lat: number, lng: number};
// }
class MapWithMarkers extends React.Component {
  
	onMarkerClustererClick = (markerClusterer) => {
		const clickedMarkers = markerClusterer.getMarkers();
		console.log(`Current clicked markers length: ${clickedMarkers.length}`);
		console.log(clickedMarkers);
	}
	render() {
		console.log('IN MAP WITH MARKERS : ', this.props.markers);
		const { markers } = this.props;
		let markersList = [];

		!isEmpty(markers) && markers.map( marker => {
		let lat = marker.latitude
		let long = marker.longitude
		if (!(lat === 0 && long === 0)){
			let hrefVal = 'https://www.google.com/maps/search/?api=1&query='+ lat + "," + long + ''
			let content = ( 
				<div>
					<p> { marker.id } </p> 
					Precision Box  {marker.accuracy }
					<br/>
					<a target="_blank" href={hrefVal}>Direction</a>
					<br/> 
					<a>Plus d'info</a>
				</div>
			);
			let position = [ lat, long ]
			markersList.push(
			<Marker position={position} key={`marker_${marker.userID}`}
			//icon={customMarkerIcon}
			/*onMouseOver={e => {
				e.target.openPopup();
			}}
			onMouseOut={e => {
				e.target.closePopup();
			}}*/
			>
				<Popup>{content}</Popup>
			</Marker>
			);
		}
	}) 

    console.log('[DEBUG], clientTrackingWithOSM, Map Leaflet, info , ',{markersList});

    return (
      <div className="map-holder">
        <MapContainer center={this.props.center} zoom={6}
          //defaultZoom={2.5}
          // defaultCenter={{ lat: 48.8547455, lng: 2.4911018 }}
          //defaultCenter={}
        >
          <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            />
            {markersList}

          {/* <MarkerClusterer
            onClick={this.onMarkerClustererClick}
            averageCenter={true}
            enableRetinaIcons={true}
            gridSize={60}
          >
            { this.props.markers.map((marker, id) => (
              <CustomMarker key={id} id={id} marker={marker} />
              // <Marker
              //   key={id}
              //   position={{ lat: marker.latitude, lng: marker.longitude }}
              //   onClick={() => props.onMarkerClick({lat: marker.latitude, lng: marker.longitude})}
              // >
              //   { position && <InfoWindow position={position} onCloseClick={this..onToggleOpen} /> }
              // </Marker>
            ))}
          </MarkerClusterer> */}
        </MapContainer>
      </div>
    );
  }
}

const MapWithAMarkerClusterer = compose(
	withStateHandlers(() => ({
		position: null,
	}), {
		onToggleOpen: (newPos) => () => ({
		position: newPos,
		})
	}),
	withProps({
		googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAoCGvddDCHzhizwAFLFnlJVoeB_hN2yvA&libraries=geometry,drawing,places',
		loadingElement: <div style={{ height: `100%` }} />,
		containerElement: <div style={{ maxHeight: `500px`, minHeight: '200px', height: 'calc(100vh - 35vh)' }} />,
		mapElement: <div style={{ height: `100%` }} />,
		markerSelected: (open) => {console.log('MARKER SELECTED : OPEN IS : '); open = !open; }
	}),
	withHandlers({
		onMarkerClustererClick: () => (markerClusterer) => {
		const clickedMarkers = markerClusterer.getMarkers();
		console.log(`Current clicked markers length: ${clickedMarkers.length}`);
		console.log(clickedMarkers);
		},
		onMarkerClick: () => (marker) => {
		console.log('Marker selected: ', marker);
		}
	})
	/*,
	withScriptjs,
	withGoogleMap
	*/
)(MapWithMarkers);
// ((props:any) =>
//   <GoogleMap
//     defaultZoom={2}
//     // defaultCenter={{ lat: 48.8547455, lng: 2.4911018 }}
//     defaultCenter={props.center}
//   >
//     <MarkerClusterer
//       onClick={props.onMarkerClustererClick}
//       averageCenter
//       enableRetinaIcons
//       gridSize={60}
//     >
//       {props.markers.map((marker: any, id: any) => (
//         <Marker
//           key={id}
//           position={{ lat: marker.latitude, lng: marker.longitude }}
//           onClick={() => props.onMarkerClick({lat: marker.latitude, lng: marker.longitude})}
//         >
//           { position && <InfoWindow position={position} onCloseClick={props.onToggleOpen} /> }
//         </Marker>
//       ))}
//     </MarkerClusterer>
//   </GoogleMap>
// );

class DemoApp extends React.PureComponent {
	state = {
		markers: {
		'ALL': [],
		'NeedTechnicalAssistance': [],
		'Prospect': [],
		'Validated': [],
		'WaitForValidation': [],
		'WaitForPayment': [],
		'HasPayed': [],
		'WaitForInstallation': [],
		'Refused': []
		},
		fetching: true,
		headerMenu: "ALL",
		// idx: 0
	};
	// Get different client type positions
  	componentDidMount= async() => {
    const clientTypes = [
        'ALL',
        'NeedTechnicalAssistance',
        'Prospect',
        'Validated',
        'WaitForValidation',
        'WaitForPayment',
        'HasPayed',
        'WaitForInstallation',
        'Refused',
    ];
    let pos = [];
    console.log('ComponentDidMount of ClientTracking: ', this.state.markers);
    try {
        console.log('CLIENT TYPES LENGTH : ', clientTypes.length);
        for (let i = 0; i < clientTypes.length; ++i) {
            console.log('======> ======> Fetching clientTypes[i] = ', clientTypes[i]);
            const response = await fetch('/user/getTrackingPos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({
                    status: clientTypes[i]
                }),
                credentials: 'same-origin'
            });
            const body = await response.json();
            console.log('Current STATUS queryed : ', clientTypes[i], ' BODY RECEIVED : ', body);
            pos[clientTypes[i]] = body.content;
        }
        console.log('POS AFTER ALL CALLS: ', pos);
        this.setState({
            markers: pos,
            fetching: false,
        });
    } catch (err) {
        console.log(err);
        this.setState({
          fetching: false,
      });
    }

	}
	  
	handleChange = (e, newHeader) => {
		console.log('====================================');
		console.log({newHeader});
		console.log('====================================');
		this.setState({headerMenu : newHeader})
	}

  	render() {
		const { markers, headerMenu, fetching } = this.state;
		let center = {lat: 0, lng: 0};

		console.log('[markers[headerMenu] : ', markers[headerMenu]);
		if (!isEmpty(markers[headerMenu])) {
		center = defineCenter(markers[headerMenu]);
		}
	
		return (
			<div>
				{ fetching ? (
					<h4 style={{ paddingBottom: '1.5rem', textAlign: 'center' }}>Chargement des données...</h4>
				) : (
					<Card>
						<AppBar position="static">
							<Tabs
								value={this.state.headerMenu}
								onChange={this.handleChange}
								indicatorColor="secondary"
								// textColor="secondary"
								variant="fullWidth"
								//variant="scrollable"
          						scrollButtons="auto"
							>
								<Tab value='ALL' label="Tous" />
								<Tab value='NeedTechnicalAssistance' label="Besoin d'assistance" />
								<Tab value='Prospect' label="Prospect" />
								<Tab value='Validated' label="Client valider" />
								<Tab value='WaitForValidation' label="En attente de validation" />
								<Tab value='WaitForPayment' label="En attente de paiement" />
								<Tab value='HasPayed' label="A payer" />
								<Tab value='WaitForInstallation' label="En attente d'installation" />
								<Tab value='Refused' label="Client refusé" />
								
							</Tabs>
						</AppBar>
						<Box p={2}>
							<MapWithAMarkerClusterer markers={markers[headerMenu]} center={center} />
						</Box>
					</Card>                  
				)}
			</div>
		);
	}
}
export default DemoApp







// const clientTypes = [
//     'Prospect'
// ];

// const average = (markers) => {
//     console.log(markers);
//     let center = markers.reduce((acc, marker) => {
//         // console.log(acc);                                                                                           
//         return acc = {
//           lat: acc.lat + marker.latitude,
//           lng: acc.lng + marker.longitude
//         };
//     }, {lat: 0, lng: 0});
//     center = {
//         lat: center.lat / markers.length,
//         lng: center.lng / markers.length
//     };
//     console.log(center);
//     // console.log('IN defineCenter : ', center);                                                                    
//     return center;
// };

// export default class TrackingMap extends React.Component {
//     // async componentWillMount() {
//     //     try {
//     //         let pos = [];
//     //         for (let i = 0; i < clientTypes.length; ++i) {
//     //             const response = await fetch('', {
//     //                 method: 'POST',
//     //                 headers: {
//     //                     'Content-Type': 'application/json',
//     //                     //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
//     //                 },
//     //                 body: JSON.stringify({
//     //                     status: clientTypes[i]
//     //                 }),
//     //                 credentials: 'same-origin'
//     //             });
//     //             const body = await response.json();
//     //             pos = [...pos, body];
//     //         }
//     //         this.setState({
//     //             posititons: pos
//     //         });
//     //     } catch (err) {
//     //         console.log(err);
//     //     }
//     // }
//     render() {
//         console.log('POSITIONS IN CLIENTTRACKING : ', this.props.positions);
//         const center = average(this.props.positions);
//         console.log(center);
//         return (
//             <Map
//                 // lat={center.lat}
//                 // lng={center.lng}
//                 lat={0}
//                 lng={0}
//                 paygoMapList={this.props.positions}
//             />
//         );
//     }
// }